<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 1000px;">
            <v-card-title>
                <h3>{{ $t("fbs") }}</h3>
            </v-card-title>
            <v-card-text>
                <v-layout wrap dense>
                    <v-flex xs12 sm3 mr-3>
                        <v-text-field
                            :label="$t('maxCantThickness')"
                            :hint="`${$t('maxCantThickness')}, ${$t('mm')}`"
                            :suffix="$t('mm')"
                            :rules="[rules.required, rules.maxCantThickness]"
                            @change="changeHandler"
                            v-model="maxCantThickness.val"
                            ref="maxCantThickness"
                            required
                            dense
                        ></v-text-field>
                        <v-text-field
                            :label="$t('maxCuttingDepth')"
                            :hint="`${$t('maxCuttingDepth')}, ${$t('mm')}`"
                            :suffix="$t('mm')"
                            :rules="[rules.required, rules.maxCuttingDepth]"
                            @change="changeHandler"
                            v-model="maxCuttingDepth.val"
                            ref="maxCuttingDepth"
                            required
                            dense
                        ></v-text-field>

                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field
                            :label="$t('minTopSideBoardsWidth')"
                            :hint="`${$t('minTopSideBoardsWidth')}, ${$t('mm')}`"
                            :suffix="$t('mm')"
                            :rules="[rules.required, rules.minTopSideBoardsWidth]"
                            @change="changeHandler"
                            v-model="minTopSideBoardsWidth.val"
                            ref="minTopSideBoardsWidth"
                            required
                            dense
                        ></v-text-field>
                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm3>
                        <v-layout wrap dense>
                            <v-checkbox
                                v-model="useCleanSaws"
                                @change="changeHandler"
                                :label="$t('cleanSawsUsed')"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-flex xs12 class="mt-2">
                                <v-text-field
                                    :label="$t('cleanKerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.cleanKerf]"
                                    @change="changeHandler"
                                    v-model="cleanKerf.val"
                                    required
                                    dense
                                    :disabled="!useCleanSaws"
                                    ref="cleanKerf"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "FBSSettings",

        data () {
            return {
                changed:          false,
                checkingInput:    false,
                disableWatch:     false,
                maxCantThickness: { val: 0, min: 0, max: 0 },
                maxCuttingDepth:  { val: 0, min: 0, max: 0 },
                minTopSideBoardsWidth: { val: 0, min: 0, max: 0 },
                useCleanSaws: false,
                cleanKerf: { val: 0, min: 0, max: 0 },
                rules: {
                    required:              value => !!value || this.$t("requiredField"),
                    maxCantThickness:      value => (value >= this.maxCantThickness.min && value <= this.maxCantThickness.max) || this.$t("incorrectValue"),
                    maxCuttingDepth:       value => (value >= this.maxCuttingDepth.min && value <= this.maxCuttingDepth.max) || this.$t("incorrectValue"),
                    minTopSideBoardsWidth: value => (value >= this.minTopSideBoardsWidth.min && value <= this.minTopSideBoardsWidth.max) || this.$t("incorrectValue"),
                    cleanKerf:             value => (value >= this.cleanKerf.min && value <= this.cleanKerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            visible: function (val) { this.changed = val ? false : this.changed; },
        },

        methods: {
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
